import EmployeesOverviewView from '@/components/routes/employees/EmployeesOverviewView.vue'
import EmployeeOverview from '@/components/routes/employees/EmployeeOverview.vue'
import EmployeeSettings from '@/components/routes/employees/settings/EmployeeSettings.vue'
import EmployeeSettingsPersonal from '@/components/routes/employees/settings/EmployeeSettingsPersonal.vue'
import EmployeeSettingsSchema from '@/components/routes/employees/settings/EmployeeSettingsSchema.vue'
import EmployeeTimesheetEditorView from '@/components/routes/employees/timesheets/EmployeeTimesheetEditorView.vue'
import TimesheetBatchEdit from '@/components/routes/employees/TimesheetBatchEdit.vue'

import EmployeeSettingsRole from '@/components/routes/employees/settings/EmployeeSettingsRole.vue'
import EmployeeSettingsDeleteEmployee from '@/components/routes/employees/settings/EmployeeSettingsDeleteEmployee.vue'
import EmployeeSettingsHolidays from '@/components/routes/employees/settings/EmployeeSettingsHolidays'
import EmployeeSettingsUserify from '@/components/routes/employees/settings/EmployeeSettingsUserify'

import fetchEmployee from './utils/fetchCurrentEmployee'
import EmployeeCreate from '@/components/routes/employees/EmployeeCreate'

const employeePrefetchSchemaRoutes = [
  {
    name: 'employee',
    path: '/employees/:employeeId',
    component: EmployeeOverview,
    props: true
  },
  {
    name: 'timesheet',
    path: '/employees/:employeeId/timesheet/:timesheetId?',
    component: EmployeeTimesheetEditorView,
    props: true
  },
  {
    name: 'employeeSettings',
    path: '/employees/:employeeId/settings',
    component: EmployeeSettings,
    redirect: {
      name: 'employeeSettings.personal'
    },
    children: [
      {
        name: 'employeeSettings.personal',
        props: true,
        path: 'personal',
        component: EmployeeSettingsPersonal
      },
      {
        name: 'employeeSettings.schema',
        props: true,
        path: 'schema',
        component: EmployeeSettingsSchema
      },
      {
        name: 'employeeSettings.holidays',
        props: true,
        path: 'holidays',
        component: EmployeeSettingsHolidays
      },
      {
        name: 'employeeSettings.userify',
        props: true,
        path: 'userify',
        component: EmployeeSettingsUserify
      },
      {
        name: 'employeeSettings.role',
        props: true,
        path: 'role',
        component: EmployeeSettingsRole
      },
      {
        name: 'employeeSettings.delete',
        props: true,
        path: 'delete',
        component: EmployeeSettingsDeleteEmployee
      }
    ]
  }].map(route => {
  route.beforeEnter = fetchEmployee
  return route
})

const employeeRoutes = [
  {
    name: 'employees',
    path: '/employees',
    component: EmployeesOverviewView,
    props: true
  },
  {
    name: 'employeeCreate',
    path: '/employees/create',
    component: EmployeeCreate,
    props: true
  },
  {
    name: 'timesheetBatchEdit',
    path: '/employees/timesheet-batch',
    component: TimesheetBatchEdit,
    props: true
  },
  ...employeePrefetchSchemaRoutes
]

export default employeeRoutes
